module.exports = __webpack_public_path__ + "static/media/data-analytics.1d8c6787.svg";